import api from '@/apis/sa/sAReturnAPI.js';
import Crud from '@/stores/crudBase';

var crud = new Crud('approveVoucherSAReturn', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sa_return',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
